// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigationmain__link{display:flex;justify-content:center}.navigationmain__items{flex:1}.navigationmain__items--section{display:flex;grid-gap:20px;gap:20px}.navigationmain__item{position:relative;color:#fff}.navigationmain__item button{font-size:1rem}.navigationmain__container{min-height:55px}@media (min-width:1220px){.navigationmain__container{min-height:76px}}", ""]);
// Exports
module.exports = exports;
